import React from 'react';
import OtpVerification from './OtpVerification';

class OtpVerificationContainer extends React.Component {
    render() {
        return (
            <OtpVerification
                showVerifyModal={this.props.showVerifyModal}
                countryCallingCode={this.props.countryCallingCode}
                mobileNumber={this.props.mobileNumber}
                email={this.props.email}>
            </OtpVerification>
        )
    }
}

export default OtpVerificationContainer;